import React from 'react';

// Components
import {
  TextInput,
  Dropdown,
  PrimaryButton,
  SecondaryButton,
  SingleSelectWithSearch
} from '../msreact-kit/packages/html-components';

export const handleGetFields = (
  fieldItem,
  handleInputChange,
  handleBlur,
  handleClick
) => {
  switch (fieldItem.attributeType) {
    case 'TEXT':
      return (
        !fieldItem.hidden && (
          <div className='home-wrapper__form__input' key={fieldItem.attributeId}>
            <TextInput
              {...fieldItem}
              handleChange={(event) => handleInputChange(event, fieldItem)}
              {...(handleBlur
                ? { handleBlur: (event) => handleBlur(event, fieldItem) }
                : {})}
            />
          </div>
        )
      );

    case 'SINGLESELECT':
      return (
        !fieldItem.hidden && (
          <div className='home-wrapper__form__input' key={fieldItem.attributeId}>
            <Dropdown
              {...fieldItem}
              handleChange={(event) => handleInputChange(event, fieldItem)}
            />
          </div>
        )
      );
    case 'SINGLE_SELECT_WITH_SEARCH':
      return (
        !fieldItem.hidden && (
          <div className='home-wrapper__form__input' key={fieldItem.attributeId}>
            <SingleSelectWithSearch
              {...fieldItem}
              handleChange={(event) => handleInputChange(event, fieldItem)}
            />
          </div>
        )
      );
    case 'PRIMARY_BUTTON':
      return (
        !fieldItem.hidden && (
          <PrimaryButton
            name={fieldItem.name}
            label={fieldItem.displayName}
            className={fieldItem.className}
            onClick={(event) => handleClick(event, fieldItem)}
            disabled={fieldItem.disabled}
            data-frok-action='button'
          />
        )
      );
    case 'SECONDARY_BUTTON':
      return (
        !fieldItem.hidden && (
          <SecondaryButton
            name={fieldItem.name}
            label={fieldItem.displayName}
            className={fieldItem.className}
            onClick={(event) => handleClick(event, fieldItem)}
            disabled={fieldItem.disabled}
            data-frok-action='button'
          />
        )
      );
    case 'COMBINE':
      return (
        !fieldItem.hidden && (
          <div className={fieldItem.className}>
            {fieldItem.attributes.map((field) => {
              return handleGetFields(
                field,
                handleInputChange,
                handleBlur,
                handleClick
              );
            })}
          </div>
        )
      );

    default:
      return;
  }
};
